import s from './ImportanceSelector.module.scss';

export const IMPORTANCE_OPTIONS = [
    { value: 'critical', label: 'Критичный' },
    { value: 'acceptable', label: 'Приемлемый' },
    { value: 'desired', label: 'Желаемый' },
];


export default function ImportanceSelector({ value, onChange, disabled = false }) {
    const current = value || 'acceptable';
    return (
        <select
            className={`${s.select} ${s[current] || ''}`}
            value={current}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
        >
            {IMPORTANCE_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
        </select>
    );
}